import React, {useMemo} from 'react';
import router, {Route} from "@/routing/Router";
import AdminLayout from "@widgets/layout/AdminLayout";
import SystemInfoOverview from "@widgets/system/SystemInfoOverview";


const SystemInfo = () => {
    const route: Route = useMemo(() => router.systemInfo, []);

    return (
        <AdminLayout currentPage={route}>
            <SystemInfoOverview/>
        </AdminLayout>
    );
};

export default SystemInfo;